export default {
    methods: {
        createVoucherStep(voucherData) {
            if (!voucherData) return null

            const voucherIsPercentageBased = voucherData.isPercentage
            const voucherAmount = voucherIsPercentageBased
                ? `${parseInt(voucherData.amount)}%`
                : this.$n(voucherData.amount, 'currency-no-decimal')
            const minimumAmount = this.$n(
                voucherData.minimumRetailerOrderTotal,
                'currency-no-decimal'
            )
            const voucherLabel = (() => {
                if (
                    voucherData.type === 'REUSABLE_NEW_CONNECTIONS' ||
                    voucherData.type === 'NEW_CONNECTIONS'
                ) {
                    return this.$t('cart.labels.voucher.new_brands_restriction')
                }
                return null
            })()

            return {
                title: voucherIsPercentageBased
                    ? this.$t('modal.voucher-modal.percent_header', {
                          0: voucherAmount,
                      })
                    : this.$t('modal.voucher-modal.header', {
                          0: voucherAmount,
                      }),
                description: voucherIsPercentageBased
                    ? this.$t('modal.voucher-modal.percent_desc_new', [
                          this.$datetime.formatDate(voucherData.endsAt),
                      ])
                    : this.$t('modal.voucher-modal.desc_new', [
                          this.$datetime.formatDate(voucherData.endsAt),
                      ]),
                backgroundColor: '#984F35',
                imageUrl: require('~assets/images/voucher-modal_img.svg'),
                extraContent: [
                    {
                        text: voucherLabel,
                    },
                    {
                        text:
                            !(+voucherData.minimumRetailerOrderTotal < 0.5) &&
                            (voucherIsPercentageBased
                                ? this.$t(
                                      'modal.voucher-modal.percent_fine_print',
                                      {
                                          0: minimumAmount,
                                      }
                                  )
                                : this.$t('modal.voucher-modal.fine_print', {
                                      0: minimumAmount,
                                  })),
                    },
                ],
                isVoucher: true,
            }
        },
    },
}
